<template>
  <div class="content-wrapper view-dxlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-list"></i> ลิสต์การวินิฉัย</h4>
          <div class="row mx-1 my-3">
            <b-form-input
              type="search"
              class="col required"
              autofocus
              v-model="filter"
              placeholder="ค้นหารายการวินิจฉัยจาก ชื่อ หรือ ประเภท"
            ></b-form-input>
            <b-button
              v-if="$canManageMasterData()"
              class="col-5 col-sm-4 col-md-3 ml-3"
              variant="primary"
              @click="openDxItemModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
            <b-button
              class="col-auto ml-2"
              variant="outline-success"
              title="ส่งออก Excel"
              aria-label="ส่งออก Excel"
              data-testid="export-excel-button"
              :disabled="!hasExportableRows"
              @click="excelExport"
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </div>
          <b-table
            id="DxListManageTable"
            ref="DxListManageTable"
            hover
            small
            sort-icon-left
            sort-by="modifyDtShow"
            :sort-desc="true"
            head-variant="light"
            :items="treatDiagList"
            :fields="fields"
            :filter="filter"
            responsive
            table-class="compact-list-table"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(buttons)="row">
              <b-button-group class="show-when-hovered" size="xs">
                <b-button
                  size=""
                  variant="outline-info"
                  :pressed="row.item.favorite"
                  @click="favToggle(row.item)"
                >
                  <i class="far fa-star"></i>
                </b-button>
                <b-button
                  v-if="$canManageMasterData() && row.item.branchId !== 0"
                  size=""
                  variant="outline-secondary"
                  @click="openDxItemModal(row.item)"
                >
                  <i class="fas fa-edit"></i>
                </b-button>
                <b-button
                  v-if="$canManageMasterData() && row.item.branchId !== 0"
                  size=""
                  variant="outline-danger"
                  @click="deleteDxItem(row.item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
        </div>
      </div>
      <DxItem ref="DxItemModal"></DxItem>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import {
  exportMasterListToExcel,
  MASTER_LIST_NO_ROWS,
} from "@/utils/masterDataExport";

import DxItem from "@/components/modal/DxItem";
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import moment from "moment";

export default {
  name: "DxListManage",
  components: {
    DxItem,
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "index",
          label: "",
          class: "text-center col-index report-export-skip",
        },
        {
          key: "code",
          label: "รหัส",
          sortable: true,
          class: "narrow-spacing col-code",
        },
        {
          key: "nameEn",
          label: "วินิจฉัย",
          sortable: true,
          class: "narrow-spacing col-name",
        },
        {
          key: "cateName",
          label: "ประเภท",
          sortable: true,
          class: "narrow-spacing col-cate",
        },
        {
          key: "creationDtShow",
          label: "วันที่สร้าง",
          sortable: true,
          class: "narrow-spacing col-date d-none d-lg-table-cell",
        },
        {
          key: "modifyDtShow",
          label: "วันที่แก้ไข",
          sortable: true,
          class: "narrow-spacing col-date d-none d-lg-table-cell",
        },
        {
          key: "buttons",
          label: "",
          class: "text-center col-buttons report-export-skip",
        },
      ],
      filter: null,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getTreatDiagList: "moduleAppointment/getTreatDiagList",
      getTreatDiagCateBy: "moduleAppointment/getTreatDiagCateBy",
      branchInfo: "moduleBranch/getBranchInfo",
      clinicInfo: "moduleBranch/getClinicInfo",
    }),
    treatDiagList() {
      const treatDiagList = [];
      this.getTreatDiagList.forEach((element) => {
        element.cateName = this.getTreatDiagCateName(element);
        element.creationDtShow = moment(element.creationDt)
          .locale("th")
          // .add(543, "year")
          .format("DD MMM YY");
        element.modifyDtShow = element.modifyDt
          ? moment(element.modifyDt).locale("th").format("DD MMM YY")
          : "";
        treatDiagList.push(element);
      });
      return treatDiagList;
    },
    hasExportableRows() {
      return this.treatDiagList.length > 0;
    },
  },
  watch: {},
  methods: {
    ...mapActions({}),
    init() {},
    moment() {
      return moment();
    },
    openDxItemModal(dxItem) {
      this.$refs.DxItemModal.show(dxItem);
    },
    favToggle(data) {
      this.isLoading = true;
      if (data.favorite == false) {
        this.$store
          .dispatch("moduleAppointment/updateTreatDiagFevorite", {
            event: data,
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else if (data.favorite == true) {
        this.$store
          .dispatch("moduleAppointment/deleteTreatDiagFevorite", {
            event: data,
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    deleteDxItem(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบการวินิฉัยนี้ ?",
        "คุณต้องการลบการวินิฉัยนี้"
      ).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("moduleAppointment/deleteTreatDiagList", {
              event: eventData,
              clinicUrl: this.$route.params.clinicUrl,
              branchUrl: this.$route.params.branchUrl,
            })
            .then((res) => {
              if (res.status == "200") {
                this.isLoading = false;
                this.showDialogToast(
                  "success",
                  `ลบรายการ "${eventData.nameEn}" สำเร็จ`
                );
              }
            })
            .catch(() => {
              this.isLoading = false;
              this.showDialogToast(
                "warning",
                `ลบรายการ "${eventData.nameEn}" ไม่สำเร็จ`
              );
            })
            .finally(() => {});
        }
      });
    },
    excelExport() {
      try {
        exportMasterListToExcel({
          tableId: "DxListManageTable",
          reportTitle: "ลิสต์การวินิจฉัย",
          reportNameEn: "DiagnosisList",
          branchName: this.branchInfo && this.branchInfo.name,
          clinicName: this.clinicInfo && this.clinicInfo.name,
        });
      } catch (err) {
        if (err && err.code === MASTER_LIST_NO_ROWS) {
          this.showDialogToast("warning", "ไม่มีข้อมูลสำหรับส่งออก");
        } else {
          this.showDialogToast("danger", "ส่งออกไฟล์ไม่สำเร็จ");
          console.error(err);
        }
      }
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    getTreatDiagCateName(val) {
      if (this.getTreatDiagCateBy(val.cateId, "id")) {
        return this.getTreatDiagCateBy(val.cateId, "id").nameTh;
      } else {
        return "";
      }
    },
  },
  updated() {
    // this.openDxItemModal();
  },
  destroyed() {
    this.$store.dispatch("moduleAppointment/fetchDiagnosisCateAndList", {
      clinicUrl: this.$route.params.clinicUrl,
      branchUrl: this.$route.params.branchUrl,
    });
  },
};
</script>

<style scoped>
</style>